export default {
  common: {
    casino: "카지노",
    more: "더보기",
    searchGames: "게임 검색",
    copied: "복사되었습니다!",
    inputTooLong: "입력 내용이 너무 깁니다. 다시 입력해 주세요.",
    inputNameCn: "중국어, 영문, 숫자, 밑줄만 입력할 수 있습니다",
    inputCapital: "대문자와 밑줄만 입력할 수 있습니다",
    inputLowercaseUnderscore: "소문자와 밑줄만 입력할 수 있습니다",
    inputLowercase: "소문자만 입력할 수 있습니다",
    inputNoSpace: "공백만 입력할 수 없습니다",
    inputValidPhone: "유효한 전화번호를 입력해 주세요",
    inputNonNumber: "숫자가 아닌 문자가 포함되어 있습니다",
    inputNonLetter: "문자가 아닌 것이 포함되어 있습니다",
    inputLetterOrNumberOnly: "영문 또는 숫자만 입력할 수 있습니다",
    phoneFormatError: "전화번호 형식이 올바르지 않습니다",
    inputLetterStartNumber: "영문으로 시작하고 숫자를 포함할 수 있습니다",
    inputNoChinese: "중국어 문자는 입력할 수 없습니다",
    inputChineseOnly: "중국어 문자만 입력할 수 있습니다",
    emailFormatError: "이메일 형식이 올바르지 않습니다",
    urlFormatError: "URL 형식이 올바르지 않습니다",
    jsonFormatError: "JSON 형식이 올바르지 않습니다",
    networkError: "서버에 연결하지 못했습니다. 잠시 후 다시 시도해 주세요.",
    siteUnavailable: "현재 이 사이트를 사용할 수 없습니다. 관리자에게 문의해 주세요.",
    tokenExpired: "세션이 만료되었습니다. 다시 로그인해 주세요.",
    domainNotAuthorized: "인증되지 않은 도메인입니다",
    demoEnvOnly: "데모 환경, 미리보기 전용입니다",
    passwordLength630: "6-30자",
    newPasswordSameAsOld: "새 비밀번호는 이전 비밀번호와 같을 수 없습니다",
    confirmNewPassword: "새 비밀번호를 확인해 주세요",
    passwordsDoNotMatch: "비밀번호가 일치하지 않습니다",
    withdrawPasswordChanged: "출금 비밀번호가 변경되었습니다",
    withdrawPasswordSet: "출금 비밀번호가 설정되었습니다",
    withdrawPasswordSetFailed: "출금 비밀번호 설정에 실패했습니다",
    phoneDigitsOnly: "전화번호는 숫자만 입력해야 합니다",
    phoneTooShort: "전화번호가 너무 짧습니다 (최소 {min}자리)",
    phoneTooLong: "전화번호가 너무 깁니다 (최대 {max}자리)",
    phoneInvalidPrefix: "유효하지 않은 전화번호 접두사입니다",
    rolloverAll: "모든 유형",
    rolloverAllStats: "전체 상태",
    rolloverSuccessful: "성공",
    rolloverFailed: "실패",
    rolloverInProgress: "진행 중",
    rolloverSuccess: "성공",
    rolloverPending: "대기 중",
    rolloverCompleted: "완료",
    rolloverCancelled: "취소됨",
    rolloverExpired: "만료됨",
    walletCash: "현금",
    walletBonus: "보너스",
    sourceDeposit: "입금",
    sourceCommission: "커미션",
    sourceManualAdd: "수동 추가",
    sourceManualSubtract: "수동 차감",
  },
  redeemCode: {
    enterTip: "보상을 받으려면 교환 코드를 입력하세요",
    placeholder: "코드를 입력해 주세요",
    redeemBtn: "교환",
    pleaseEnterCode: "교환 코드를 입력해 주세요",
    redeemSuccess: "교환 성공!",
    redeemFailed: "교환 실패, 다시 시도해 주세요",
  },
}
